var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 87,
    viewBox: "0 0 75 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.3254 83.4965C57.5461 88.0762 52.2729 87.3623 47.2466 85.203C41.9029 83.0003 37.0178 82.8609 31.3742 85.203C24.3463 88.1981 20.6163 87.3274 16.3836 83.4965C-7.51317 59.205 -3.98597 22.2019 23.1735 20.8088C29.7605 21.1571 34.3724 24.4047 38.2523 24.6746C44.0193 23.5166 49.5393 20.1994 55.7119 20.6347C63.1279 21.2268 68.6744 24.1173 72.378 29.3152C57.1228 38.3701 60.7382 58.2212 74.75 63.7934C71.9459 71.0635 68.3481 78.2464 62.3166 83.5575L62.3254 83.4965ZM37.7232 20.5476C37.0089 9.75142 45.871 0.870663 56.0646 0C57.4667 12.4505 44.6012 21.7666 37.7232 20.5476Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleWhite);
export default __webpack_public_path__ + "static/media/apple-white.2aa2165fd02072f5ab73330a33809cef.svg";
export { ForwardRef as ReactComponent };